import RectangleGroupIcon from "@heroicons/react/24/outline/RectangleGroupIcon";
import PlayCircleIcon from "@heroicons/react/24/solid/PlayCircleIcon";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { styled as styling } from "@mui/material/styles";
import ReactPlayer from "react-player";
import Color from "../../../../assets/colors";

export const GridStyled = styling(Grid)((props) => ({
  //
}));

export const ImageStyled = styling("img")((props) => ({
  objectFit: "cover",
  width: "100%",
  borderRadius: "10px",
  height: "100%",
  cursor: "pointer",

  [props.theme.breakpoints.down("tablet")]: {
    minWidth: "300px",
  },
}));

export const FirstImageStyled = styling("img")((props) => ({
  objectFit: "cover",
  width: "100%",
  borderRadius: "10px",
  height: "100%",
  cursor: "pointer",

  [props.theme.breakpoints.down("tablet")]: {
    minWidth: "300px",
  },
}));

export const ReactPlayerStyled = styling(ReactPlayer)((props) => ({
  minWidth: "100%",
  minHeight: "100%",
  objectFit: "cover",
  overflow: "hidden",
}));

export const PlayIconStyled = styling(PlayCircleIcon)((props) => ({
  strokeWidth: "0.5px",
  stroke: "rgba(0, 0, 0, 0.38)",
  color: Color.white,
  width: "50px",
  height: "50px",
}));

export const ShowAllMediaButton = styling(Button)((props) => ({
  padding: "5px 7px",
  border: `1px solid ${Color.black}`,
  gap: "12px",
  textTransform: "capitalize",
  position: "absolute",
  right: "10px",
  bottom: "10px",
  backgroundColor: Color.white,
  color: Color.black,

  "&:hover": {
    backgroundColor: Color.white,
    boxShadow: "0px 4px 0px 0px rgba(0,0,0,1)",
    border: `1.5px solid ${Color.black}`,
  },
}));

export const ShowAllMediaIcon = styling(RectangleGroupIcon)((props) => ({
  height: "24px",
  width: "24px",
}));

export const OutlinedButton = styling(Button)((props) => ({
  gap: "10px",
  textTransform: "capitalize",
  color: Color.black,
  fontSize: "16px",
  lineHeight: "19px",
  fontWeight: "700",
  padding: "15px 30px",
  borderRadius: "8px",
  minWidth: "200px",
  minHeight: "48px",
  marginBottom: "30px",

  backgroundColor: Color.white,
  border: `1.5px solid ${Color.black}`,

  "&:hover": {
    backgroundColor: Color.white,
    boxShadow: "0px 4px 0px 0px rgba(0,0,0,1)",
    border: `1.5px solid ${Color.black}`,
  },

  [props.theme.breakpoints.down("tablet")]: {
    width: "100%",
  },
}));
